import {Component, inject, Input, ViewChild} from '@angular/core';
import {UserReport, UserReportMetric} from "../../../models/report/UserReport";
import {DataTypeGroupEnum} from "../../../enums/dashboard/DataTypeUnitEnum";
import {BaseComponent} from "../../BaseComponent";
import {DashboardService} from "../../../services/dashboard/dashboard.service";
import {UserMetricInstance} from "../../../models/user/Metric/UserMetricInstance";
import {AggregateFunctionTypeEnum, BucketUnitEnum} from "../../../enums/dashboard/ChartsEnum";
import {DxFormComponent} from "devextreme-angular";

@Component({
  selector: 'app-user-report-form',
  templateUrl: './user-report-form.component.html',
  styleUrls: ['./user-report-form.component.css', '../../common/drawer-style.css', '../../registry/base-component-with-drawer.component.css']
})
export class UserReportFormComponent extends BaseComponent {

  @ViewChild('reportForm') reportForm?: DxFormComponent;
  @ViewChild('bucketForm') bucketForm?: DxFormComponent;

  @Input() set report(value: UserReport) {
    this._report = value;
    if (!value.id && !value.email) {
      this._report.email = this.gmService.user?.email ?? '';
    }
  }
  get report(): UserReport { return this._report; }
  private _report: UserReport = new UserReport();

  @Input() disabled: boolean = false;

  protected dashboardService = inject(DashboardService);
  protected readonly bucketUnitValues = Object.values(BucketUnitEnum);
  protected readonly aggregateFunctionValues = Object.values(AggregateFunctionTypeEnum);
  protected readonly DataTypeGroupEnum = DataTypeGroupEnum;

  protected getBucketUnitLabel = (value: string) => {
    const label: string = this.translate.instant('DATE_SELECTION.REALTIME.PLURAL.' + value);
    return label.charAt(0).toUpperCase() + label.slice(1);
  };

  validate(): boolean {
    const form1Valid = this.reportForm?.instance?.validate().isValid ?? false;
    const form2Valid = this.bucketForm?.instance?.validate().isValid ?? false;
    const cronValid = !!this.report.unixCronExpression;
    return form1Valid && form2Valid && cronValid;
  }

  convertSelectedMetric(selMetric: UserMetricInstance): void {
    if (selMetric.dataTypeGroup === DataTypeGroupEnum.STRING) {
      this.toastService.openErrorToastMessage(this.translate.instant('DASHBOARD.REPORTS.INVALID_DATA_TYPE'));
      return;
    }
    const newMetric = new UserReportMetric();
    newMetric.metricInstance = structuredClone(selMetric) as any;
    newMetric.functionType = AggregateFunctionTypeEnum.MEAN;
    this.report.metrics ??= [];
    this.report.metrics.push(newMetric);
  }

  removeMetric(index: number): void {
    this.report.metrics?.splice(index, 1);
  }
}
